import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
export default {
    /**
     * @param {import("../model/RegisterModel").RegisterModel} params /module/Register/model/RegisterModel.js
     */
    apiRegister: function (params) {
        let url = ConfigManager.getApiModuleUrl() + "/tni/front_end_questionnaire_answer"
        return BzbsApi.connectBzbsPostJson(url, null, params.getParams()).pipe(map((res) => {
            return res.data;
        }));
    },
    //#region sms register
    /**
     * 
     * @param {import("@/module/Register/model/SmsRegisterModel").RegisterSmsCheckContactNumberModel} idCard 
     * @returns {Promise}
     */
    apiCheckContactNumber: function (params) {
        let url = ConfigManager.getApiModuleUrl() + "/tni/mobile"
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, null, params).subscribe({
                next: (resp) => {
                    resolve(resp.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    /**
     * 
     * @param {import("@/module/Register/model/SmsRegisterModel").RegisterOtpModel} params 
     * @returns {Promise}
     */
    apiRequestOtp: function (info, channel, lineId) {
        const params = {
            citizenid: info.idCard,
            contact_number: info.mobileNo,
            lineid: lineId,
            localeId: 1054,
            channel: channel, //"authen" flow update tel use "contact_number"
        };
        let url = ConfigManager.getApiModuleUrl() + "/tni/otp"
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => { 
            return res.data;
        }));
    },
    /**
     * 
     * @param {import("@/module/Register/model/SmsRegisterModel").RegisterSmsModel} params 
     * @returns {Promise}
     */
    apiRegisterSms: function (code, info) {
        const params = {
            citizenid: info.idCard,
            otp: code,
            refcode: info.refCode
        }
        let url = ConfigManager.getApiModuleUrl() + "/tni/register"
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => { 
            return res.data;
        }));
    },
    //#endregion sms register
    apiGetLiffLine: function() {
        let url = ConfigManager.getBlobUrl() + `/webconfig/tni/liff_line_config.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
}
